import styled, { css } from 'styled-components';

export const BaseLabel = css`
  font-weight: 700;
  margin-bottom: 10px;
`

export const Label = styled.label`
  font-weight: 700;
  cursor: pointer;
`; 